export default "__VITE_PUBLIC_ASSET__a0673375__"